import { type RefObject, useEffect } from 'react';

/** Focuses `ref` when `when` turns true (on mount by default), optionally selecting its text. */
export function useAutoFocus(
  ref: RefObject<HTMLElement | null>,
  when = true,
  { select = false }: { select?: boolean } = {},
): void {
  useEffect(() => {
    const element = ref.current;
    if (!when || !element) {
      return;
    }
    element.focus();
    if (select && (element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement)) {
      element.select();
    }
  }, [ref, when, select]);
}
